import { v4 as uuidv4 } from 'uuid'
import { captureEvent } from '@sentry/react'

import { UserAttributionService } from '../services/userAttributionService'
import useAuthorization from '../hooks/useAuthorization'
import useQueryIsIPAddressBanned from '../hooks/useQueryIsIPAddressBanned'

const GrabInformation = () => {
  const utmParameters = new URLSearchParams(window.location.search)
  const params = utmParameters.size > 0 ? Object.fromEntries(utmParameters.entries()) : null

  if (params) {
    if (!params.transaction_id) {
      params.transaction_id = uuidv4()
    }
    const userAttr = new UserAttributionService()
    userAttr.saveUserAttribution(params)
  }
  const signupAttr = params?.transaction_id

  const { isBanned } = useQueryIsIPAddressBanned()
  const { handleAuthorization } = useAuthorization(isBanned, signupAttr)

  captureEvent({
    message: 'Initiate-auth component used',
    level: 'warning',
  })
  handleAuthorization()
}

export default GrabInformation
